"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("../../../../utils");
var _constant = require("../../../../constant");
var _ = require("../../..");
var _styled = require("../../../base/styled");
var _styled2 = require("../styled");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Culture = function Culture(_ref) {
  var company = _ref.company,
    open = _ref.open,
    onCollapse = _ref.onCollapse,
    isValid = _ref.isValid,
    showValidateIcon = _ref.showValidateIcon;
  return /*#__PURE__*/_react.default.createElement(_.Collapsible, {
    id: _constant.companySection.CULTURE,
    onCollapse: onCollapse,
    title: "Culture",
    open: open.culture,
    isValid: isValid,
    showValidateIcon: showValidateIcon
  }, (company.cultureImageUrl || company.culture) && /*#__PURE__*/_react.default.createElement(_styled2.BlockText, null, /*#__PURE__*/_react.default.createElement(_styled2.Title, null, "Our Culture"), company.cultureImageUrl && /*#__PURE__*/_react.default.createElement(_.FilePreview, {
    url: company.cultureImageUrl,
    fileName: company.cultureImageName,
    imageHeight: "100%",
    imageWidth: "100%"
  }), /*#__PURE__*/_react.default.createElement(_styled.Text, {
    $bsStyle: {
      fontStyle: 'italic'
    }
  }, company.cultureCaption), /*#__PURE__*/_react.default.createElement(_styled.PreformattedText, null, company.culture)), (company.mission || company.missionLink) && /*#__PURE__*/_react.default.createElement(_styled2.BlockText, null, /*#__PURE__*/_react.default.createElement(_styled2.Title, null, "Mission Statement"), /*#__PURE__*/_react.default.createElement(_styled.PreformattedText, null, company.mission), /*#__PURE__*/_react.default.createElement(_styled2.Anchor, {
    $bsStyle: {
      marginBottom: '0px'
    },
    href: company.missionLink,
    target: "_blank",
    rel: "noopener noreferrer"
  }, (0, _utils.getUrlWithoutProtocol)(company.missionLink))), (company.diversityMean || company.diversityLink) && /*#__PURE__*/_react.default.createElement(_styled2.BlockText, null, /*#__PURE__*/_react.default.createElement(_styled2.Title, null, "What does diversity mean to us?"), /*#__PURE__*/_react.default.createElement(_styled.PreformattedText, null, company.diversityMean), /*#__PURE__*/_react.default.createElement(_styled2.Anchor, {
    $bsStyle: {
      marginBottom: '0px'
    },
    href: company.diversityMeanLink,
    target: "_blank",
    rel: "noopener noreferrer"
  }, (0, _utils.getUrlWithoutProtocol)(company.diversityMeanLink))), company.hiveCulturalKeywords[0] && /*#__PURE__*/_react.default.createElement(_styled2.BlockText, null, /*#__PURE__*/_react.default.createElement(_styled2.Title, null, "Cultural & Career Keywords"), company.hiveCulturalKeywords.map(function (keyword) {
    return /*#__PURE__*/_react.default.createElement(_styled.Text, {
      key: keyword.id
    }, keyword.name);
  })), (company.socialImpact || company.socialImpactLink || company.socialImpactImageUrl) && /*#__PURE__*/_react.default.createElement(_styled2.BlockText, null, /*#__PURE__*/_react.default.createElement(_styled2.Title, null, "Social Impact Areas of Focus | Corporate Responsibility"), /*#__PURE__*/_react.default.createElement(_styled.PreformattedText, null, company.socialImpact), /*#__PURE__*/_react.default.createElement(_styled2.Anchor, {
    href: company.socialImpactLink,
    target: "_blank",
    rel: "noopener noreferrer",
    $bsStyle: {
      marginBottom: '16px'
    }
  }, (0, _utils.getUrlWithoutProtocol)(company.socialImpactLink)), company.socialImpactImageUrl && /*#__PURE__*/_react.default.createElement(_styled2.ImageWrapper, {
    src: company.socialImpactImageUrl
  })));
};
Culture.propTypes = {
  company: _utils.companyProps.isRequired,
  open: _utils.opportunitySectionsProps.isRequired,
  onCollapse: _propTypes.default.func.isRequired,
  isValid: _propTypes.default.bool.isRequired,
  showValidateIcon: _propTypes.default.bool
};
Culture.defaultProps = {
  showValidateIcon: false
};
var _default = Culture;
exports.default = _default;